"use strict";

window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () {
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function () {
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('click activate');
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('keydown');
  }
};
window.PXUTheme.contentCreator.slideshow = {
  init: function () {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      lazyLoad: 2
    });
  }
};
window.PXUTheme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
window.PXUTheme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: function (url, view) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let data;
    if (url in deferred) {
      return deferred[url];
    }
    const $deferred = $.Deferred();
    deferred[url] = $deferred;
    if (options.hash) {
      data = sessionStorage.getItem(url);
      if (data) {
        const deserialized = JSON.parse(data);
        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};
        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }
        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }
        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};
window.PXUTheme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};
window.PXUTheme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${window.PXUTheme.translation.page_text} ${currentPage} ${window.PXUTheme.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};
window.PXUTheme.debounce = function (func, wait, immediate) {
  let timeout = null;
  return () => {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};
window.PXUTheme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]');

    // Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }
    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }
      $disclosureWrap.removeClass('disclosure--left');
    }

    // Close menus on ESC
    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    });

    // Close menus on hoverout
    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    });

    // Close menus on hoverout
    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    });

    // On click/focus event for toggling options
    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    // Mobile toggle logic
    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);
      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    });

    // Mobile form submitting
    $mobileMenuDisclosureList.on('change', function (e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');
        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};
window.PXUTheme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link');

  // Grab dropdowns
  const dropdowns = $('.navbar-dropdown');

  // Grab megamenus

  const megamenus = $('.has-mega-menu');

  // Listen for enter key
  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show dropdown
        $(this).closest('.navbar-item').addClass('show-dropdown');

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  });

  // Listen for enter key
  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }
        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        }

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
  });

  // Listen for enter key
  megamenus.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show megamenu
        $(this).find('.mega-menu').addClass('mega-menu--show');

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });

    // Hide mega menu on focusout
    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
      }
    });
  });
};
window.PXUTheme.collapsibleRowUtil = {
  init: selector => {
    const headingSelector = selector || '.faq-accordion';
    const $faqHeading = $(`${headingSelector} > dt > button`);
    $(`${headingSelector} > dd`).attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.off('click activate').on('click activate', e => {
      const $target = $(e.currentTarget);
      const $faqIcons = $target.find('.icon');
      const $plus = $target.find('.plus');
      const $state = $target.attr('aria-expanded') === 'false';
      $plus.toggleClass('collapsed');
      $target.attr('aria-expanded', $state);
      $target.parent().next().slideToggle(() => {
        $faqIcons.toggleClass('icon--active');
      });
      $target.parent().next().attr('aria-hidden', !$state);
      return false;
    });
  },
  unload: selector => {
    const headingSelector = selector || '.faq-accordion';
    $(`${headingSelector} > dt > button`).off('click activate');
    $(`${headingSelector} > dt > button`).off('keydown');
  }
};
window.PXUTheme.newsletterAjaxForm = {
  init: function () {
    // Selectors
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    $ajaxForm.each(function () {
      const $form = $(this);
      $form.on('submit', function (e) {
        if ($('input[name="challenge"]', $form).val() !== "true") {
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
              $form.fadeOut("slow", () => {
                $form.prev('.form__success-message').html(window.PXUTheme.translation.newsletter_form_success);
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $form).val('true');
              $form.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  unload: function () {
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    const $submitButton = $ajaxForm.find(':submit');
    $submitButton.off();
  }
};
window.PXUTheme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  const $dataEl = $section.find(`[data-section-data][data-section-id=${sectionId}]`).first();
  if (!$dataEl) return {};

  // Load data from attribute, or innerHTML
  const data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};
window.PXUTheme.infiniteScroll = {
  init() {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').off('click', '[data-load-more]');
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      window.PXUTheme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').off('click', '[data-load-more-infinite]');
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      window.PXUTheme.infiniteScroll.enableInfinite();
      $(this).remove();

      // Prevent link from going to next page
      e.stopPropagation();
      return false;
    });
    if ($('[data-load-infinite-scroll]').length) {
      window.PXUTheme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage(url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url,
      beforeSend() {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails);

        // Initialize product reviews
        window.PXUTheme.productReviews.init();

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl === 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(`${location.protocol}//${location.host}`);
      }
    });
  },
  enableInfinite() {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad() {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad() {
        // Initialize product reviews
        window.PXUTheme.productReviews.init();
      }
    });
  },
  unload() {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
    $('[data-load-more-infinite]').off();
  }
};
window.PXUTheme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }
    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }
    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};
window.PXUTheme.loadScript = function (name, url, callback) {
  if (window.PXUTheme[name]) {
    callback;
  } else {
    $.ajax({
      url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};
window.PXUTheme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery__wrapper--vertical-masonry');
  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};
window.PXUTheme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery__wrapper--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};
window.PXUTheme.mobileMenu = {
  init: function () {
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
    $('body').on('click', '[data-show-mobile-menu="false"]', function () {
      window.PXUTheme.mobileMenu.open();
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function () {
      window.PXUTheme.mobileMenu.close();
    });
    if (window.PXUTheme.jsHeader.enable_sticky === true) {
      this.enableSticky();
    }
  },
  open: function () {
    //Get current position on page
    let currentScrollPosition = window.scrollY;
    $('body').attr('data-current-position', currentScrollPosition);

    // Calculate height of mobile content area
    let announcementHeight = 0;
    let mobileHeaderHeight = parseInt($('.mobile-header').height());
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $('.mobile-menu').css({
      height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`
    });
    $('.mobile-menu__content').css({
      marginBottom: `${mobileHeaderHeight + announcementHeight}px`
    });
    this.$mobileMenuIcon.addClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);
    if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      window.PXUTheme.jsAjaxCart.hideDrawer();
    }

    //Set delay on menu open to get proper page position
    setTimeout(function () {
      $('body').addClass('mobile-menu--opened');
    }, 10);
  },
  close: function () {
    $('body').removeClass('mobile-menu--opened');

    // Once mobile menu is closed, return back to previous position on page
    let lastScrollPosition = $('body').data('current-position');
    window.scrollTo(0, lastScrollPosition);
    this.$mobileMenuIcon.removeClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
  },
  enableSticky: function () {
    window.PXUTheme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      offset = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset
    }).on('sticky-start', () => {
      var headerheight = $('#mobile-header').height();
      var annoucementHeight = $('.announcement-sticky-wrapper').height();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');
      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function ($section) {
    $('[data-mobilemenu-toggle]').off();
    $('.mobile-menu__toggle-icon').off();
    $('.mobile-menu .close-dropdown').off();
    this.disableSticky();
  }
};

/* option_selection.js */
function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof Shopify) var Shopify = {};
Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}, Shopify.map = function (t, e) {
  for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
  return o;
}, Shopify.arrayIncludes = function (t, e) {
  for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
  return !1;
}, Shopify.uniq = function (t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
  return e;
}, Shopify.isDefined = function (t) {
  return "undefined" == typeof t ? !1 : !0;
}, Shopify.getClass = function (t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}, Shopify.extend = function (t, e) {
  function o() {}
  o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype;
}, Shopify.locationSearch = function () {
  return window.location.search;
}, Shopify.locationHash = function () {
  return window.location.hash;
}, Shopify.replaceState = function (t) {
  window.history.replaceState({}, document.title, t);
}, Shopify.urlParam = function (t) {
  var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
  return e && decodeURIComponent(e[1].replace(/\+/g, " "));
}, Shopify.newState = function (t, e) {
  var o;
  return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash();
}, Shopify.setParam = function (t, e) {
  Shopify.replaceState(Shopify.newState(t, e));
}, Shopify.Product = function (t) {
  Shopify.isDefined(t) && this.update(t);
}, Shopify.Product.prototype.update = function (t) {
  for (let property in t) this[property] = t[property];
}, Shopify.Product.prototype.optionNames = function () {
  return "Array" == Shopify.getClass(this.options) ? this.options : [];
}, Shopify.Product.prototype.optionValues = function (t) {
  if (!Shopify.isDefined(this.variants)) return null;
  var e = Shopify.map(this.variants, function (e) {
    var o = "option" + (t + 1);
    return void 0 == e[o] ? null : e[o];
  });
  return null == e[0] ? null : Shopify.uniq(e);
}, Shopify.Product.prototype.getVariant = function (t) {
  var e = null;
  return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) {
    for (var i = !0, r = 0; r < t.length; r++) {
      var n = "option" + (r + 1);
      o[n] != t[r] && (i = !1);
    }
    return 1 == i ? void (e = o) : void 0;
  }), e);
}, Shopify.Product.prototype.getVariantById = function (t) {
  for (var e = 0; e < this.variants.length; e++) {
    var o = this.variants[e];
    if (t == o.id) return o;
  }
  return null;
}, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }
  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
      a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
      s = n[1] ? r + n[1] : "";
    return a + s;
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    a = e || this.money_format;
  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;
    case "amount_no_decimals":
      r = i(t, 0);
      break;
    case "amount_with_space_separator":
      r = i(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      r = i(t, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      r = i(t, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, " ", ".");
  }
  return a.replace(n, r);
}, Shopify.OptionSelectors = function (t, e) {
  return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0;
}, Shopify.OptionSelectors.prototype.initDropdown = function () {
  var t = {
      initialLoad: !0
    },
    e = this.selectVariantFromDropdown(t);
  if (!e) {
    var o = this;
    setTimeout(function () {
      o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t);
    });
  }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
  this.selectors[0].element.onchange(t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
  var e = this.selectVariantFromParams(t);
  e || this.selectVariantFromDropdown(t);
}, Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
  var e = document.getElementById(t),
    o = e.parentNode;
  Shopify.each(this.buildSelectors(), function (t) {
    o.insertBefore(t, e);
  }), e.style.display = "none", this.variantIdField = e;
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
  var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
  if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
  var o = e.value;
  return this.selectVariant(o, t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
  var e = Shopify.urlParam("variant");
  return this.selectVariant(e, t);
}, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
  var o = this.product.getVariantById(t);
  if (null == o) return !1;
  for (var i = 0; i < this.selectors.length; i++) {
    var r = this.selectors[i].element,
      n = r.getAttribute("data-option"),
      a = o[n];
    null != a && this.optionExistInSelect(r, a) && (r.value = a);
  }
  return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
  for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
}, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
  Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
  var o = document.getElementById(t);
  Shopify.each(this.buildSelectors(), function (t) {
    o.appendChild(t);
  });
}, Shopify.OptionSelectors.prototype.buildSelectors = function () {
  for (var t = 0; t < this.product.optionNames().length; t++) {
    var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
    e.element.disabled = !1, this.selectors.push(e);
  }
  var o = this.selectorDivClass,
    i = this.product.optionNames(),
    r = Shopify.map(this.selectors, function (t) {
      var e = document.createElement("div");
      if (e.setAttribute("class", o), i.length > 1) {
        var r = document.createElement("label");
        r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r);
      }
      return e.appendChild(t.element), e;
    });
  return r;
}, Shopify.OptionSelectors.prototype.selectedValues = function () {
  for (var t = [], e = 0; e < this.selectors.length; e++) {
    var o = this.selectors[e].element.value;
    t.push(o);
  }
  return t;
}, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
  var o = this.selectedValues(),
    i = this.product.getVariant(o);
  i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e);
}, Shopify.OptionSelectorsFromDOM = function (t, e) {
  var o = e.optionNames || [],
    i = e.priceFieldExists || !0,
    r = e.delimiter || "/",
    n = this.createProductFromSelector(t, o, i, r);
  e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!Shopify.isDefined(o)) var o = !0;
  if (!Shopify.isDefined(i)) var i = "/";
  var r = document.getElementById(t),
    n = r.childNodes,
    a = (r.parentNode, e.length),
    s = [];
  Shopify.each(n, function (t, r) {
    if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
      var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
      0 == e.length && (a = n.length - (o ? 1 : 0));
      var p = n.slice(0, a),
        l = o ? n[a] : "",
        c = (t.getAttribute("value"), {
          available: t.disabled ? !1 : !0,
          id: parseFloat(t.value),
          price: l,
          option1: p[0],
          option2: p[1],
          option3: p[2]
        });
      s.push(c);
    }
  });
  var p = {
    variants: s
  };
  if (0 == e.length) {
    p.options = [];
    for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
  } else p.options = e;
  return p;
}, Shopify.SingleOptionSelector = function (t, e, o, i) {
  this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");
  for (var r = 0; r < i.length; r++) {
    var n = document.createElement("option");
    n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n);
  }
  return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) {
    i = i || {}, t.updateSelectors(e, i);
  }, !0;
}, Shopify.Image = {
  preload: function (t, e) {
    for (var o = 0; o < t.length; o++) {
      var i = t[o];
      this.loadImage(this.getSizedImageUrl(i, e));
    }
  },
  loadImage: function (t) {
    new Image().src = t;
  },
  switchImage: function (t, e, o) {
    if (t && e) {
      var i = this.imageSize(e.src),
        r = this.getSizedImageUrl(t.src, i);
      o ? o(r, t, e) : e.src = r;
    }
  },
  imageSize: function (t) {
    var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
    return null != e ? e[1] : null;
  },
  getSizedImageUrl: function (t, e) {
    if (null == e) return t;
    if ("master" == e) return this.removeProtocol(t);
    var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != o) {
      var i = t.split(o[0]),
        r = o[0];
      return this.removeProtocol(i[0] + "_" + e + r);
    }
    return null;
  },
  removeProtocol: function (t) {
    return t.replace(/http(s)?:/, "");
  }
}, Shopify.OptionSelectors.HistoryState = function (t) {
  this.browserSupports() && this.register(t);
}, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
  window.addEventListener("popstate", function (e) {
    t.selectVariantFromParamsOrDropdown({
      popStateCall: !0
    });
  });
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
  this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id));
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
  return window.history && window.history.replaceState;
};

/*============================================================================
Product media controls
==============================================================================*/

window.PXUTheme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.PXUTheme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      window.PXUTheme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
window.PXUTheme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.PXUTheme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};
window.PXUTheme.quantityBox = {
  cartEnterCaptureHandler: null,
  init: function () {
    if (!window.PXUTheme.quantityBox.cartEnterCaptureHandler) {
      window.PXUTheme.quantityBox.cartEnterCaptureHandler = function (e) {
        const isEnter = e.key === 'Enter' || e.keyCode === 13;
        if (!isEnter || !e.target) {
          return;
        }
        const $target = $(e.target);
        const isCartQuantityInput = $target.hasClass('quantity-input') &&
          $target.parents('[data-line-item]').length > 0;
        if (!isCartQuantityInput) {
          return;
        }
        e.preventDefault();
        window.PXUTheme.quantityBox.commitCartInputQuantity($target);
      };
      document.addEventListener('keydown', window.PXUTheme.quantityBox.cartEnterCaptureHandler, true);
    }
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function (e) {
      window.PXUTheme.quantityBox.handleQuantityInputEvent(e, $(this));
    });
  },
  handleQuantityInputEvent: function (e, $input) {
    const isCartInput = $input.parents('[data-line-item]').length > 0;
    if (!isCartInput) {
      window.PXUTheme.quantityBox.updateQuantity($input);
      return;
    }

    if (e.type !== 'change') {
      return;
    }
    window.PXUTheme.quantityBox.commitCartInputQuantity($input);
  },
  commitCartInputQuantity: function ($input) {
    const quantity = String($input.val());
    if ($input.data('lastCommittedQuantity') === quantity) {
      return false;
    }
    $input.data('lastCommittedQuantity', quantity);
    window.PXUTheme.quantityBox.updateQuantity($input);
    $input.data('lastCommittedQuantity', String($input.val()));
    return true;
  },
  moveFocusBeforeQuantityControlDisable: function ($control, $input, willDisable) {
    if (willDisable && $control.is(':focus')) {
      $input.trigger('focus');
    }
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    const focusTarget = $el.hasClass('quantity-input') ? 'input' : $el.data('update-quantity') || 'input';
    const isCartInput = $el.parents('[data-line-item]').length > 0;
    const renderedQuantity = parseInt($input.prop('defaultValue'));
    const rawInputValue = String($input.val()).trim();
    const numericCartValue = Number(rawInputValue);
    const validCartInteger = rawInputValue !== '' &&
      /^[+-]?\d+$/.test(rawInputValue) &&
      Number.isFinite(numericCartValue) &&
      Number.isInteger(numericCartValue);
    let val = isCartInput ? numericCartValue : parseInt(rawInputValue);
    let valMax = 100000000000000000;
    let valMin = parseInt($input.attr('min')) || 0;
    let correctionMessage = '';
    if ($input.attr('max') != null) {
      valMax = parseInt($input.attr('max'));
    }
    const previousCartQuantity = Number.isNaN(renderedQuantity)
      ? Number.isNaN(val) ? valMin : val
      : renderedQuantity;
    if (isCartInput && !validCartInteger) {
      val = Math.min(Math.max(previousCartQuantity, valMin), valMax);
      $input.val(val);
      correctionMessage = `Invalid quantity. Quantity changed to ${val}.`;
    } else if (val < valMin) {
      val = valMin;
      $input.val(valMin);
      correctionMessage = `Minimum quantity is ${valMin}. Quantity changed to ${valMin}.`;
      if (!isCartInput) {
        return false;
      }
    } else if (val > valMax) {
      val = valMax;
      $input.val(valMax);
      correctionMessage = `Maximum quantity is ${valMax}. Quantity changed to ${valMax}.`;
      if (!isCartInput) {
        return false;
      }
    }
    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    // Update quantity if within cart (vs on the product page)
    if (isCartInput) {
      const lineID = $quantityBox.data('line-item-key');
      window.PXUTheme.quantityBox.updateCart(
        lineID,
        val,
        focusTarget,
        previousCartQuantity,
        correctionMessage
      );
    }

    // Keep focus on an available control before disabling the active control.
    const updateDirection = $el.data('update-quantity');
    const controlWillBeDisabled = (updateDirection === 'minus' && val <= valMin) ||
      (updateDirection === 'plus' && val >= valMax);
    window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable($el, $input, controlWillBeDisabled);

    // Call to update quantity controls
    window.PXUTheme.quantityBox.updateQuantityControls($el);
  },
  ensureCartStatus: function () {
    let $status = $('#cart-quantity-status');
    if (!$status.length) {
      $('body').append('<p id="cart-quantity-status" class="is-sr-only" role="status" aria-live="polite" aria-atomic="true"></p>');
      $status = $('#cart-quantity-status');
    }
    return $status;
  },
  formatCartSubtotal: function (totalPrice) {
    const moneyFormat = $('body').attr('data-money-format') || Shopify.money_format;
    return Shopify.formatMoney(totalPrice, moneyFormat).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  },
  setCartStatus: function (message) {
    const $status = window.PXUTheme.quantityBox.ensureCartStatus();
    window.clearTimeout(window.PXUTheme.quantityBox.cartStatusTimer);
    $status.text('');
    window.PXUTheme.quantityBox.cartStatusTimer = window.setTimeout(function () {
      $status.text(message);
    }, 50);
  },
  announceCartUpdate: function (cart, lineItem, requestedQuantity, correctionMessage) {
    const actualQuantity = lineItem && typeof lineItem.quantity !== 'undefined' ? lineItem.quantity : requestedQuantity;
    const productTitle = lineItem && (lineItem.title || lineItem.product_title) ? lineItem.title || lineItem.product_title : 'Item';
    const subtotal = window.PXUTheme.quantityBox.formatCartSubtotal(cart.total_price);
    const stockCapped = Number(requestedQuantity) > Number(actualQuantity);
    const resultMessage = stockCapped
      ? `${productTitle} quantity limited to ${actualQuantity} based on available stock. Cart subtotal ${subtotal}.`
      : `${productTitle} quantity ${actualQuantity}. Cart subtotal ${subtotal}.`;
    const message = correctionMessage && !stockCapped
      ? `${correctionMessage} ${resultMessage}`
      : resultMessage;
    window.PXUTheme.quantityBox.setCartStatus(message);
  },
  restoreCartQuantityFocus: function (lineID, focusTarget) {
    window.setTimeout(function () {
      const $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box').first();
      const targetSelector = focusTarget === 'plus'
        ? '.quantity-plus'
        : focusTarget === 'minus'
          ? '.quantity-minus'
          : '.quantity-input';
      let $focusTarget = $quantityBox.find(targetSelector).first();

      if (!$focusTarget.length || $focusTarget.is('[disabled]')) {
        $focusTarget = $quantityBox.find('.quantity-input').first();
      }
      if ($focusTarget.length) {
        if (!$focusTarget.is('button, input, select, textarea, a[href], [tabindex]')) {
          $focusTarget.attr('tabindex', '-1');
        }
        $focusTarget.trigger('focus');
      }
    }, 0);
  },
  cartUpdateQueues: {},
  updateCart: function (lineID, quantity, focusTarget, previousQuantity, correctionMessage) {
    window.PXUTheme.quantityBox.ensureCartStatus();
    $('.quantity-warning').removeClass('animated bounceIn');
    const request = {
      quantity: quantity,
      focusTarget: focusTarget,
      correctionMessage: correctionMessage || ''
    };
    let queue = window.PXUTheme.quantityBox.cartUpdateQueues[lineID];
    if (!queue) {
      const confirmedQuantity = Number(previousQuantity);
      queue = {
        active: false,
        confirmedQuantity: Number.isFinite(confirmedQuantity) ? confirmedQuantity : Number(quantity),
        pending: null
      };
      window.PXUTheme.quantityBox.cartUpdateQueues[lineID] = queue;
    }
    if (queue.active) {
      queue.pending = request;
      return;
    }
    window.PXUTheme.quantityBox.performCartUpdate(lineID, request, queue);
  },
  continueCartUpdateQueue: function (lineID, queue) {
    queue.active = false;
    if (queue.pending) {
      const nextRequest = queue.pending;
      queue.pending = null;
      window.PXUTheme.quantityBox.performCartUpdate(lineID, nextRequest, queue);
      return true;
    }
    delete window.PXUTheme.quantityBox.cartUpdateQueues[lineID];
    return false;
  },
  resyncCartAfterUpdateError: function (lineID, request, queue, message) {
    const providerMessage = /[.!?]$/.test(message) ? message : `${message}.`;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json',
      success: function (cart) {
        const updatedLineItem = cart.items[lineID - 1] || null;
        const actualLineQuantity = updatedLineItem ? Number(updatedLineItem.quantity) : 0;
        const productTitle = updatedLineItem && (updatedLineItem.title || updatedLineItem.product_title)
          ? updatedLineItem.title || updatedLineItem.product_title
          : 'Item';
        const subtotal = window.PXUTheme.quantityBox.formatCartSubtotal(cart.total_price);
        const visibleMessage = `${providerMessage} Actual quantity is ${actualLineQuantity}. Cart subtotal ${subtotal}.`;
        const statusMessage = `Cart quantity update reported an issue. ${providerMessage} ${productTitle} quantity ${actualLineQuantity}. Cart subtotal ${subtotal}.`;
        const stockCapped = Number(request.quantity) > actualLineQuantity;
        const hasPendingUpdate = Boolean(queue.pending);

        $('.cart__form').data('currentDiscount', cart.total_discount);
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }

        const $updatedLine = $(`[data-line-item="${lineID}"]`);
        const $updatedQuantityBox = $updatedLine.find('.product-quantity-box').first();
        const $updatedInput = $updatedQuantityBox.find('.quantity-input').first();
        const $quantityWarning = $updatedLine.find('.quantity-warning').first();
        $quantityWarning.text(visibleMessage).addClass('animated bounceIn');
        if ($updatedInput.length) {
          $updatedInput.removeData('lastCommittedQuantity');
          window.PXUTheme.quantityBox.updateQuantityControls($updatedInput);
        }
        if (stockCapped) {
          const $updatedPlus = $updatedQuantityBox.find('.quantity-plus').first();
          window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable(
            $updatedPlus,
            $updatedInput,
            request.focusTarget === 'plus'
          );
          $updatedPlus.attr('disabled', true);
        }

        queue.confirmedQuantity = actualLineQuantity;
        window.PXUTheme.quantityBox.setCartStatus(statusMessage);
        if (hasPendingUpdate) {
          $updatedInput.trigger('focus');
          window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
          return;
        }
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, request.focusTarget);
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      },
      error: function () {
        const $line = $(`[data-line-item="${lineID}"]`);
        const $input = $line.find('.quantity-input').first();
        const restoredQuantity = Number(queue.confirmedQuantity);
        const recoveryFocusTarget = queue.pending ? queue.pending.focusTarget : request.focusTarget;
        const pendingMessage = queue.pending ? ' Pending quantity changes were not sent.' : '';
        let restoredMessage = '';
        if (Number.isFinite(restoredQuantity)) {
          $input.val(restoredQuantity).prop('defaultValue', restoredQuantity);
          window.PXUTheme.quantityBox.updateQuantityControls($input);
          restoredMessage = ` Displayed quantity restored to ${restoredQuantity} temporarily.`;
        }
        const recoveryMessage = `${providerMessage} Cart status could not be confirmed.${restoredMessage}${pendingMessage} Reload the cart before trying again.`;
        $line.find('.quantity-warning').first().text(`Quantity update could not be confirmed. ${recoveryMessage}`).addClass('animated bounceIn');
        $input.removeData('lastCommittedQuantity');
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, recoveryFocusTarget);
        window.PXUTheme.quantityBox.setCartStatus(`Cart quantity update could not be confirmed. ${recoveryMessage}`);
        queue.pending = null;
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      }
    });
  },
  performCartUpdate: function (lineID, request, queue) {
    const quantity = request.quantity;
    const focusTarget = request.focusTarget;
    const correctionMessage = request.correctionMessage;
    queue.active = true;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let updatedLineItem = null;
        let itemsLeftText = '';
        let warningText = '';
        const $currentDiscount = $('.cart__form').data('currentDiscount');

        //check to see if there are correct amount of products in array
        const cartItemsLineID = lineID - 1;
        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          updatedLineItem = cart.items[cartItemsLineID];
          newQuantity = updatedLineItem.quantity;
        }
        if (updatedLineItem) {
          for (let i = 0; i < cart.items.length; i++) {
            if (i != cartItemsLineID) {
              if (cart.items[i].id == updatedLineItem.id) {
                newQuantity += cart.items[i].quantity;
              }
            }
          }
        }
        const actualLineQuantity = updatedLineItem ? updatedLineItem.quantity : quantity;
        const stockCapped = Number(quantity) > Number(actualLineQuantity);
        if (stockCapped) {
          warningText = `Only ${actualLineQuantity} available. Quantity changed to ${actualLineQuantity}.`;
        } else if (correctionMessage) {
          warningText = correctionMessage;
        } else if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
            }
            warningText = `${newQuantity} ${itemsLeftText}`;
          }
        }

        //Update total discount value
        $('.cart__form').data('currentDiscount', cart.total_discount);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }
        const $updatedLine = $(`[data-line-item="${lineID}"]`);
        const $updatedQuantityBox = $updatedLine.find('.product-quantity-box').first();
        const $updatedInput = $updatedQuantityBox.find('.quantity-input').first();
        const $quantityWarning = $updatedLine.find('.quantity-warning').first();
        const hasPendingUpdate = Boolean(queue.pending);

        $quantityWarning.text('');
        if (warningText && !hasPendingUpdate) {
          $quantityWarning.text(warningText).addClass('animated bounceIn');
        }
        if ($updatedInput.length) {
          window.PXUTheme.quantityBox.updateQuantityControls($updatedInput);
        }
        if (stockCapped) {
          const $updatedPlus = $updatedQuantityBox.find('.quantity-plus').first();
          window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable(
            $updatedPlus,
            $updatedInput,
            focusTarget === 'plus'
          );
          $updatedPlus.attr('disabled', true);
        }
        queue.confirmedQuantity = Number(actualLineQuantity);
        if (hasPendingUpdate) {
          $updatedInput.trigger('focus');
          window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
          return;
        }
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, focusTarget);
        window.PXUTheme.quantityBox.announceCartUpdate(cart, updatedLineItem, quantity, correctionMessage);
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      },
      error: function (XMLHttpRequest, textStatus) {
        let response = XMLHttpRequest.responseJSON;
        if (!response && XMLHttpRequest.responseText) {
          try {
            response = JSON.parse(XMLHttpRequest.responseText);
          } catch (error) {
            response = null;
          }
        }
        const message = response && (response.description || response.message)
          ? response.description || response.message
          : 'We could not update this quantity. Try again.';
        window.PXUTheme.quantityBox.resyncCartAfterUpdateError(lineID, request, queue, message);
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
window.PXUTheme.queryParameters = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      window.PXUTheme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
window.PXUTheme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

    // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);
      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};
function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = window.PXUTheme.translation.notify_form_email;
  const notifyEmailValue = window.PXUTheme.translation.contact_email;
  const notifySend = window.PXUTheme.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';
  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.toLowerCase() === 'default title' ? variant.name.replace(/"/g, '&quot;') : variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${window.PXUTheme.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${window.PXUTheme.translation.email_content} | ${notifyUrl}`;
  }
  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${window.PXUTheme.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = $slider.data('flickity');
      const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');
      if ($slider.is(':visible') && $sliderInstance !== undefined) {
        $sliderInstance.select(index, false, true);
      }
    });
  }

  // Emits custom event
  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');
  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }
  if (variant && variant.available) {
    const variantWithInventory = {
      ...variant,
      ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
    };
    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        let itemsLeftText = window.PXUTheme.translation.product_count_other;
        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = window.PXUTheme.translation.product_count_one;
        }
        const inventoryThreshold = window.PXUTheme.theme_settings.inventory_threshold;
        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity);

        // Check to see if quantity selector should be disabled based on inventory remaining
        window.PXUTheme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }
    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));

    // Initialize shopify payment buttons
    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);
    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }
  } else {
    // No purchasable variant. Three contexts:
    // - a variant is selected but sold out -> "Sold out"
    // - options are not fully selected yet (e.g. auto-select disabled) -> prompt to choose
    // - a complete selection maps to no available variant -> "Unavailable"
    const notSelected = !variant && state === 'not-selected';
    let message;
    if (variant) {
      message = window.PXUTheme.translation.soldOut;
    } else if (notSelected) {
      message = window.PXUTheme.translation.select_variant;
    } else {
      message = window.PXUTheme.translation.unavailable;
    }
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    // Don't surface a sold-out style notice when the shopper simply hasn't chosen options yet.
    if (!notSelected) $('.sold_out', $product).text(message);
    $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', notSelected ? 'true' : null).find('span:not(.icon)').text(message);
    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
}
window.selectCallback = selectCallback;

/* eslint-disable */
window.PXUTheme.predictiveSearch = {
  vars: {
    term: '',
    searchResourceType: null
  },
  mobileSearchFocusTimer: null,
  mobileSearchFocusGeneration: null,
  mobileSearchIsOpen: false,
  mobileSearchLastTouchAt: 0,
  mobileSearchLastTouchTarget: null,
  mobileSearchBodyWidth: null,
  init: function () {
    this.unload();
    $('[data-show-search-trigger], [data-autocomplete-true] input')
      .off('.pxuMobileSearchOpen')
      .on('click.pxuMobileSearchOpen touchstart.pxuMobileSearchOpen', function (e) {
        if (!isScreenSizeLarge()) {
          e.stopPropagation();

          const predictiveSearch = window.PXUTheme.predictiveSearch;
          const eventTime = Date.now();

          if (e.type === 'touchstart') {
            predictiveSearch.mobileSearchLastTouchAt = eventTime;
            predictiveSearch.mobileSearchLastTouchTarget = e.currentTarget;
          } else if (e.type === 'click') {
            const isCompatibilityClick = predictiveSearch.mobileSearchLastTouchTarget === e.currentTarget &&
              eventTime - predictiveSearch.mobileSearchLastTouchAt <= 750;
            predictiveSearch.mobileSearchLastTouchAt = 0;
            predictiveSearch.mobileSearchLastTouchTarget = null;

            if (isCompatibilityClick) {
              return;
            }
          }

          if (predictiveSearch.mobileSearchIsOpen) {
            return;
          }

          predictiveSearch.mobileSearchFocusGeneration = window.PXUTheme.jsHeader.captureSearchReturnFocus(e.currentTarget);
          const formType = $(this).closest('form').find('[name="type"]').val();
          predictiveSearch.showMobileSearch(formType);
        }
      });
    $('.search-form .search__fields input[type="text"], .search-form .field input[type="text"]').on('focus', e => {
      const dataSearchResourceType = e.target.closest('[data-search-resource-type]');
      if (dataSearchResourceType) {
        window.PXUTheme.predictiveSearch.vars.searchResourceType = dataSearchResourceType.getAttribute('data-search-resource-type');
      }

      // Set the cursor at the end of the input field for better UX,
      // otherwise it may be at the beginning of the input field when the input gets focus.
      const searchInputEl = e.target;
      const searchInputVal = searchInputEl.value.trim();
      searchInputEl.setSelectionRange(searchInputVal.length, searchInputVal.length);
      window.PXUTheme.predictiveSearch.getResults(searchInputVal, $(e.target.closest('.search-form')));
    });

    // Clicking outside makes the results disappear.
    $(document).on('click focusout', function (e) {
      if (window.PXUTheme.media_queries.large.matches) {
        const searchForm = $(e.target).parents('.search-form');
        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide();

          // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
          // since unlockBodyScroll won't get called in jsHeader.
          if ((window.PXUTheme.theme_settings.header_layout === 'vertical' || window.PXUTheme.theme_settings.header_layout === 'search_focus') && document.documentElement.classList.contains('scroll-locked')) {
            window.PXUTheme.predictiveSearch.unlockBodyScroll();
          }
        }
      }
    });
    $("[data-autocomplete-true] form").on("submit", function (e) {
      const query = $(this).find('input[name="q"]').val().trim();
      if (!query) e.preventDefault();
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]');
      const resultWrapper = `<div class="search__results-wrapper"></div>`;
      $(resultWrapper).appendTo($this);
      input.attr('autocomplete', 'off').on('input', window.PXUTheme.debounce(() => {
        window.PXUTheme.predictiveSearch.vars.term = this.querySelector('[data-q]').value.trim();
        window.PXUTheme.predictiveSearch.getResults(window.PXUTheme.predictiveSearch.vars.term, $this);
      }, 200));
    });
    window.addEventListener('resize', window.PXUTheme.debounce(() => {
      if (window.PXUTheme.theme_settings.header_layout === 'vertical') {
        window.PXUTheme.predictiveSearch.alignVerticalSearch();
      }
      this.resizeSearchResults();
    }, 150));
    $('body')
      .off('keyup.pxuPredictiveSearch')
      .on('keyup.pxuPredictiveSearch', e => this.onKeyUp(e));
  },
  onKeyUp: function (e) {
    if (e.code === 'Escape') {
      $('[data-q]').val('');
      window.PXUTheme.predictiveSearch.vars.term = '';
      if ($('.mobile-search').is(':visible') || $('.mobile-search').hasClass('mobile-search--visible')) {
        window.PXUTheme.predictiveSearch.hideMobileSearch();
      } else {
        window.PXUTheme.jsHeader.hideSearch();
      }
    }
  },
  resizeSearchResults: function () {
    let inputFieldEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('[data-autocomplete-true]');
    const innerHeight = window.innerHeight;
    const inputFieldElBottom = inputFieldEl.getBoundingClientRect().bottom;
    const offset = isScreenSizeLarge() ? 30 : 10;
    const resultsMaxHeight = `${innerHeight - inputFieldElBottom - offset}px`;
    const resultsContainerEl = inputFieldEl.closest('[data-autocomplete-true]').querySelector('.search__results-wrapper');
    resultsContainerEl.style.setProperty('--results-max-height', resultsMaxHeight);
  },
  getResults: function (term, $this) {
    const {
      header_layout
    } = window.PXUTheme.theme_settings;
    if (term.length === 0) {
      if (header_layout === 'vertical' || header_layout === 'search_focus') {
        window.PXUTheme.predictiveSearch.unlockBodyScroll();
      }
      window.PXUTheme.predictiveSearch.clearResults();
      return;
    }
    const {
      searchResourceType
    } = window.PXUTheme.predictiveSearch.vars;
    const restrictResourceCondition = searchResourceType && 'searchResourceType' in $this[0].dataset;
    fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search${restrictResourceCondition ? `&resources[type]=${searchResourceType}` : ''}`).then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    }).then(text => {
      window.PXUTheme.predictiveSearch.displayResults(text, $this);

      // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
      // since lockBodyScroll won't get called in jsHeader (due to the search icon trigger not being present).
      // lockBodyScroll has to be called here so the overlay appears at about the same time as the results.
      if ((header_layout === 'vertical' || header_layout === 'search_focus') && $this.closest('.jsHeader').length > 0) {
        window.PXUTheme.predictiveSearch.lockBodyScroll();
      }
    }).catch(error => {
      throw error;
    });
  },
  displayResults: function (results, $this) {
    const $fields = $this.find('.search__fields');
    const $resultsWrapper = $this.find('.search__results-wrapper');
    $resultsWrapper.show();
    $resultsWrapper.empty();
    $resultsWrapper.append(results);
    const inputFieldEls = $fields.length > 0 ? Array.from($fields) : document.querySelectorAll('[data-autocomplete-true]');

    // Calculate resultsWrapper max height for header search (exclude blog sidebar)
    inputFieldEls.forEach(el => {
      if (el.closest('.search-popup__form') || el.closest('.mobile-search')) {
        this.resizeSearchResults(el);
      }
    });
    if ($this.parents('.vertical-header__content').length && window.PXUTheme.jsHeader.header_layout === 'vertical') {
      window.PXUTheme.predictiveSearch.alignVerticalSearch();
    }
  },
  clearResults: function () {
    const wrapperEls = document.querySelectorAll('.search-form .search__results-wrapper');
    wrapperEls.forEach(el => {
      // This should be more performant than `innerHTMl = ""`
      while (el.firstChild) el.removeChild(el.firstChild);
    });
  },
  showMobileSearch: function (formType) {
    let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (this.mobileSearchIsOpen) {
      return;
    }

    this.mobileSearchIsOpen = true;

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }

    const focusGeneration = this.mobileSearchFocusGeneration;

    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').stop(true, false).fadeIn(200, function () {
      $(this).addClass('mobile-search--visible');
    });
    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      this.mobileSearchFocusTimer = setTimeout(function () {
        window.PXUTheme.predictiveSearch.mobileSearchFocusTimer = null;
        if (window.PXUTheme.predictiveSearch.mobileSearchIsOpen &&
            window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration === focusGeneration) {
          $('.mobile-search input[data-q]').focus();
        }
      }, 205);
    }
    const bodyStyle = document.body.style;
    this.mobileSearchBodyWidth = {
      value: bodyStyle.getPropertyValue('width'),
      priority: bodyStyle.getPropertyPriority('width')
    };
    bodyStyle.setProperty('width', '100%');
    bodyStyle.position = 'fixed';
    bodyStyle.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    }
    $('.search-form .close-search')
      .off('click.pxuMobileSearch touchstart.pxuMobileSearch')
      .on('click.pxuMobileSearch touchstart.pxuMobileSearch', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.PXUTheme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      });
    $('.search-form .submit-search')
      .off('click.pxuMobileSearch touchstart.pxuMobileSearch')
      .on('click.pxuMobileSearch touchstart.pxuMobileSearch', function (e) {
      $(this).parents('form').submit();
      });
    $(document).off('click.pxuMobileSearch').on('click.pxuMobileSearch', e => {
      if (!e.target.closest('.search-form') && $('.mobile-search').is('.mobile-search--visible')) {
        window.PXUTheme.predictiveSearch.hideMobileSearch();
      }
    });
  },
  hideMobileSearch: function () {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!this.mobileSearchIsOpen) {
      return;
    }

    this.mobileSearchIsOpen = false;
    const focusGeneration = this.mobileSearchFocusGeneration;

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    this.restoreMobileSearchBodyWidth();
    window.scrollTo(0, position);
    $('.mobile-search').stop(true, false).fadeOut(200, function () {
      if (window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration === focusGeneration) {
        window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration = null;
      }
      window.PXUTheme.jsHeader.restoreSearchReturnFocus(focusGeneration);
    }).removeClass('mobile-search--visible');
    $('.search-form .close-search, .search-form .submit-search').off('.pxuMobileSearch');
    $(document).off('.pxuMobileSearch');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
    window.PXUTheme.predictiveSearch.unlockBodyScroll();
  },
  restoreMobileSearchBodyWidth: function () {
    if (this.mobileSearchBodyWidth === null) {
      return;
    }

    const bodyStyle = document.body.style;
    if (this.mobileSearchBodyWidth.value === '') {
      bodyStyle.removeProperty('width');
    } else {
      bodyStyle.setProperty('width', this.mobileSearchBodyWidth.value, this.mobileSearchBodyWidth.priority);
    }
    this.mobileSearchBodyWidth = null;
  },
  lockBodyScroll: function () {
    document.documentElement.classList.add('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.remove('site-overlay--hidden');
  },
  unlockBodyScroll: function () {
    document.documentElement.classList.remove('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.add('site-overlay--hidden');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    const hadMobileSearchSession = this.mobileSearchFocusGeneration !== null || this.mobileSearchIsOpen;

    if (hadMobileSearchSession && window.PXUTheme.jsHeader) {
      window.PXUTheme.jsHeader.clearSearchReturnFocus();
    }

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }

    this.mobileSearchFocusGeneration = null;
    this.mobileSearchIsOpen = false;
    this.mobileSearchLastTouchAt = 0;
    this.mobileSearchLastTouchTarget = null;

    $('.mobile-search').stop(true, false).hide().removeClass('mobile-search--visible');

    if (hadMobileSearchSession) {
      $('body').css('max-height', 'none');
      document.body.style.position = '';
      document.body.style.top = '';
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    }

    this.restoreMobileSearchBodyWidth();

    $('body').off('focus', '[data-autocomplete-true] input');
    $('body').off('.pxuPredictiveSearch');
    $('input[name="q"]').off();
    $('[data-show-search-trigger], [data-autocomplete-true] input').off('.pxuMobileSearchOpen');
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search-form .close-search, .search-form .submit-search').off('.pxuMobileSearch');
    $(document).off('.pxuMobileSearch');
    $('.search__results-wrapper').remove();
  }
};
function isScreenSizeLarge() {
  if (window.PXUTheme.media_queries.large.matches) {
    return true;
  }
}
window.PXUTheme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};
window.PXUTheme.tabs = {
  enableTabs: function () {
    let $tabs = $('.tabs li, .tabs li a');
    $tabs.on('click', function (el) {
      el.preventDefault();

      // toggle active tab
      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      let $tabIndex = $(this).index();
      let $tabContent = $(this).parents('.tabs').next('.tabs-content');

      // toggle corresponding tab content
      $tabContent.children('li, li a').removeClass('is-active active');
      $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').show().css({
        'display': 'block'
      }).siblings().hide().removeClass('is-active');
    });
  },
  unload: function () {
    $('.tabs li, .tabs li a').off();
  }
};
class ProductCard {
  enableSwatches() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.swatch span', _ref => {
        let {
          currentTarget
        } = _ref;
        if ($(currentTarget).data('image') && $(currentTarget).data('image').indexOf('no-image') === -1) {
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
        }
      });
    }
  }
  showVariantImage() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.addClass('swap--visible');
        $secondaryImage.removeClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.enableVideoOnHover($(this));
        }
      });
      $('body').on('mouseleave', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.removeClass('swap--visible');
        $secondaryImage.addClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.disableVideoOnHover($(this));
        }
      });
    }
  }
  cancelQuickShopFocusReturn() {
    if (this.quickShopFocusReturnFrame !== null && this.quickShopFocusReturnFrame !== undefined) {
      window.cancelAnimationFrame(this.quickShopFocusReturnFrame);
    }
    this.quickShopFocusReturnFrame = null;
  }
  restoreQuickShopFocus(target, generation) {
    this.cancelQuickShopFocusReturn();
    this.quickShopFocusReturnFrame = window.requestAnimationFrame(() => {
      this.quickShopFocusReturnFrame = null;
      if (this.quickShopFocusReturnGeneration !== generation || !target || !target.isConnected) return;
      if (typeof target.matches !== 'function' || !target.matches('button.js-quick-shop-link')) return;
      if (target.disabled || target.closest('[aria-hidden="true"]')) return;

      const scrollX = window.pageXOffset;
      const scrollY = window.pageYOffset;
      const productImage = target.closest('.product-image__wrapper');
      if (!productImage) return;

      productImage.classList.add('quick-shop--focus-return');
      if (!target.getClientRects().length) {
        productImage.classList.remove('quick-shop--focus-return');
        return;
      }

      try {
        try {
          target.focus({
            preventScroll: true
          });
        } catch (_error) {
          target.focus();
        }
      } finally {
        productImage.classList.remove('quick-shop--focus-return');
        if (window.pageXOffset !== scrollX || window.pageYOffset !== scrollY) {
          window.scrollTo(scrollX, scrollY);
        }
      }
    });
  }
  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      let quickShopFocusTarget = e.currentTarget;
      const requestGeneration = (this.quickShopRequestGeneration || 0) + 1;
      this.quickShopRequestGeneration = requestGeneration;
      window.PXUTheme.jsProductClass.load($currentTarget.data('url')).then(_ref2 => {
        let {
          html
        } = _ref2;
        if (this.quickShopRequestGeneration !== requestGeneration || $('.fancybox-active').length) {
          quickShopFocusTarget = null;
          return;
        }

        $('.js-quick-shop').html(html.content);
        $('.js-quick-shop [data-section-data]').attr('data-section-id', 'quickshop');
        $('.js-quick-shop .js-product_section').addClass('quickshop');
        this.cancelQuickShopFocusReturn();
        const focusGeneration = (this.quickShopFocusReturnGeneration || 0) + 1;
        this.quickShopFocusReturnGeneration = focusGeneration;
        let quickShopFancyboxInstance = null;
        quickShopFancyboxInstance = $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            beforeShow: () => {
              // Enable tabs
              if (document.querySelectorAll('.tabs').length > 0) {
                window.PXUTheme.tabs.enableTabs();
              }
              // Enable accordions
              if (document.querySelectorAll('.accordion').length > 0) {
                window.PXUTheme.contentCreator.accordion.init();
              }
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              window.PXUTheme.jsProduct.init($('.js-quick-shop'));
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');
            },
            beforeClose: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            },
            afterClose: instance => {
              if (instance !== quickShopFancyboxInstance) return;

              const focusTarget = quickShopFocusTarget;
              quickShopFocusTarget = null;
              quickShopFancyboxInstance = null;
              this.restoreQuickShopFocus(focusTarget, focusGeneration);
            }
        });
      }).catch(error => {
        quickShopFocusTarget = null;
        console.error(error);
      });
    });
  }
}
window.PXUTheme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
window.PXUTheme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  getVideoTitle: function (video) {
    if (!video) return '';
    const slide = video.closest('.product-gallery__image[data-title]');
    const iframe = video.querySelector && video.querySelector('iframe[title]');
    const title = slide && slide.getAttribute('data-title') || video.getAttribute('aria-label') || video.getAttribute('title') || iframe && iframe.getAttribute('title') || '';
    return title.trim();
  },
  prepareVideoPlayer: function (video) {
    const title = this.getVideoTitle(video);
    if (!title) return;
    let config = {};
    const configJSON = video.getAttribute('data-plyr-config');
    if (configJSON) {
      try {
        const parsedConfig = JSON.parse(configJSON);
        if (parsedConfig && typeof parsedConfig === 'object' && !Array.isArray(parsedConfig)) {
          config = parsedConfig;
        }
      } catch (_error) {
        config = {};
      }
    }
    config.title = title;
    video.setAttribute('data-plyr-config', JSON.stringify(config));
  },
  setupPlayerAccessibility: function (player) {
    if (!player || player.__pxuMediaAccessibilityReady) return;
    const container = player.elements && player.elements.container;
    const title = player.config && typeof player.config.title === 'string' ? player.config.title.trim() : '';
    if (!container || !title) return;
    player.__pxuMediaAccessibilityReady = true;
    const frameTitleTemplate = player.config.i18n && player.config.i18n.frameTitle || 'Player for {title}';
    const playerLabel = frameTitleTemplate.replace('{title}', title);
    const updateAccessibility = () => {
      const playAction = player.config.i18n && player.config.i18n.play || 'Play';
      const pauseAction = player.config.i18n && player.config.i18n.pause || 'Pause';
      const action = player.playing ? pauseAction : playAction;
      container.querySelectorAll('[data-plyr="play"]').forEach(button => {
        button.setAttribute('aria-label', `${action}, ${title}`);
      });
      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.setAttribute('title', playerLabel);
      }
    };
    container.setAttribute('role', 'group');
    container.setAttribute('aria-label', playerLabel);
    player.on('ready', updateAccessibility);
    player.on('play', updateAccessibility);
    player.on('pause', updateAccessibility);
    player.on('ended', updateAccessibility);
    updateAccessibility();
    // Provider iframes (e.g. YouTube) are created and repeatedly re-titled by the
    // provider after Plyr's own lifecycle events; re-apply the product name whenever
    // it drifts. Bounded to 30 s and to this container's lifetime.
    if (typeof MutationObserver === 'function') {
      const iframeObserver = new MutationObserver(() => {
        if (!container.isConnected) {
          iframeObserver.disconnect();
          return;
        }
        const iframe = container.querySelector('iframe');
        if (iframe && iframe.getAttribute('title') !== playerLabel) {
          updateAccessibility();
        }
      });
      iframeObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['title'] });
      window.setTimeout(() => iframeObserver.disconnect(), 30000);
    }
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    Array.from(productVideos).forEach(video => this.prepareVideoPlayer(video));
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, (index, player) => {
      player.loop = videoLooping;
      this.setupPlayerAccessibility(player);
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;
      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }

      // When a video is playing, pause any other instances
      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;
          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};

/* R37 CART DISCOUNT RECOVERY — Ultimate Special Offers SECTION renderer.
 * Provider reloads the cart on Apply and renders a blank input with no error,
 * no value retention, and no focus return. This controller preserves the
 * attempted code, surfaces the provider's own computed result (summary_html
 * verbatim), restores value and focus for correction, and never announces a
 * state the provider did not compute. USO keeps full ownership of validation
 * and discount application. Inspected 2026-09-25; remove if Orbit ships a
 * native fix. */
(function () {
  'use strict';

  var CONTROLLER_ID = 'msgR37DiscountRecovery';
  var STORAGE_KEY = 'msgR37DiscountAttempt';
  var MAX_ATTEMPT_AGE_MS = 120000;
  var RENDER_TIMEOUT_MS = 10000;

  function isCartPage() {
    return /^\/cart(\.html)?([/?#]|$)/.test(window.location.pathname);
  }

  function findApplyButtons(scope) {
    var root = scope || document;
    return root.querySelectorAll(
      '.saso-use-discount-code-cart-apply, #saso-use-discount-code-cart-apply',
    );
  }

  function inputForApply(button) {
    if (!button || typeof button.closest !== 'function') return null;
    var container = button.closest(
      '.saso-use-discount-code-cart-container, #saso-use-discount-code-cart, form, div',
    );
    if (!container) return null;
    return container.querySelector(
      '.saso-use-discount-code-cart-code, #saso-use-discount-code-cart-code',
    );
  }

  function currentDiscountInput() {
    var buttons = findApplyButtons(document);
    for (var i = 0; i < buttons.length; i += 1) {
      var input = inputForApply(buttons[i]);
      if (input) return input;
    }
    return document.querySelector(
      '.saso-use-discount-code-cart-code, #saso-use-discount-code-cart-code',
    );
  }

  function readAttempt() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var attempt = JSON.parse(raw);
      if (!attempt || attempt.pathname !== window.location.pathname) return null;
      if (Date.now() - attempt.attemptedAt > MAX_ATTEMPT_AGE_MS) return null;
      return attempt;
    } catch (_error) {
      return null;
    }
  }

  function clearAttempt() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_error) { /* noop */ }
  }

  function ensureLabel(input) {
    if (!input.id) input.id = CONTROLLER_ID + 'Code';
    var labelId = CONTROLLER_ID + 'Label';
    if (document.getElementById(labelId)) return;
    var labelledby = input.getAttribute('aria-labelledby') || '';
    var hasLabel = labelledby || (input.getAttribute('aria-label') || '') ||
      (input.id && document.querySelector('label[for="' + input.id + '"]'));
    if (hasLabel) return;
    var label = document.createElement('label');
    label.id = labelId;
    label.className = 'is-sr-only';
    label.setAttribute('for', input.id);
    label.textContent = 'Discount code';
    input.setAttribute('aria-labelledby', labelId);
    input.parentNode.insertBefore(label, input);
  }

  function ensureStatusNode(input) {
    var statusId = CONTROLLER_ID + 'Status';
    var existing = document.getElementById(statusId);
    if (existing) return existing;
    var status = document.createElement('p');
    status.id = statusId;
    status.className = 'cart-warning';
    status.setAttribute('aria-atomic', 'true');
    if (input.parentNode) input.parentNode.insertBefore(status, input.nextSibling);
    return status;
  }

  function describeOutcome(data) {
    var discounts = data && data.discounts ? data.discounts : {};
    var summary = typeof discounts.summary_html === 'string' ? discounts.summary_html : '';
    var text = summary.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    var validField = discounts.discount_code_cart_valid;
    var total = typeof discounts.total_discount_amount === 'number'
      ? discounts.total_discount_amount
      : parseFloat(discounts.total_discount_amount) || 0;

    if (validField === true || total > 0) {
      return { kind: 'success', message: text || 'Discount code applied.' };
    }
    if (validField === false || /did not match/i.test(text)) {
      return { kind: 'invalid', message: text || "We couldn't apply this discount code. Check the code and try again." };
    }
    if (text) {
      // Provider computed something we do not recognize; surface it verbatim as a
      // neutral status instead of guessing validity.
      return { kind: 'neutral', message: text };
    }
    return { kind: 'unconfirmed', message: "We couldn't confirm this discount code. Check the code and try again." };
  }

  function exposeOutcome(input, attempt, outcome) {
    ensureLabel(input);
    var status = ensureStatusNode(input);
    status.textContent = outcome.message;

    if (outcome.kind === 'invalid' || outcome.kind === 'unconfirmed') {
      status.setAttribute('role', 'alert');
      status.setAttribute('aria-live', 'assertive');
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', status.id);
    } else {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      input.removeAttribute('aria-invalid');
      if (outcome.kind === 'success') {
        input.removeAttribute('aria-describedby');
      }
    }

    if (outcome.kind === 'invalid' || outcome.kind === 'unconfirmed') {
      input.value = attempt.value;
      if (typeof input.focus === 'function') {
        try {
          input.focus({ preventScroll: true });
        } catch (_error) {
          input.focus();
        }
      }
    }
  }

  function start() {
    if (!isCartPage()) return;
    if (window[CONTROLLER_ID]) return;
    window[CONTROLLER_ID] = true;

    // 1. Capture the attempt (capture phase; never intercepts the provider's click).
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var button = target.closest(
        '.saso-use-discount-code-cart-apply, #saso-use-discount-code-cart-apply',
      );
      if (!button) return;
      var input = inputForApply(button);
      if (!input || !input.value || !input.value.trim()) return;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          value: input.value,
          attemptedAt: Date.now(),
          pathname: window.location.pathname,
        }));
      } catch (_error) { /* noop */ }
    }, true);

    // 2. Chain the provider completion hook; never alter its response.
    var priorHook = typeof window.SASOComplete === 'function' ? window.SASOComplete : null;
    var recoveryDone = false;

    function recover(data) {
      if (recoveryDone) return data;
      var attempt = readAttempt();
      if (!attempt) return data;

      var outcome = describeOutcome(data);
      var deadline = Date.now() + RENDER_TIMEOUT_MS;

      function finish() {
        var input = currentDiscountInput();
        if (!input) {
          if (Date.now() < deadline) {
            window.setTimeout(finish, 200);
          } else {
            clearAttempt();
          }
          return;
        }
        recoveryDone = true;
        exposeOutcome(input, attempt, outcome);
        clearAttempt();
      }

      window.setTimeout(finish, 0);
      return data;
    }

    window.SASOComplete = function (data) {
      var result = data;
      if (priorHook) {
        try {
          var returned = priorHook(data);
          if (returned) result = returned;
        } catch (error) {
          window.setTimeout(function () { throw error; }, 0);
        }
      }
      try {
        recover(result);
      } catch (_error) { /* never break the provider hook */ }
      return result;
    };

    // 3. Clean up across Shopify section reloads and page navigations.
    document.addEventListener('shopify:section:unload', function () {
      if (event.target && event.target.querySelector && event.target.querySelector('.saso-use-discount-code-cart-code')) {
        clearAttempt();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R17 CHECKOUT ACTIVATION WATCHDOG — Ultimate Special Offers checkout interception.
 * USO preventDefault()s the Checkout button and replaces submission with an async
 * POST plus a scripted redirect; its 4-second checkout_start guard and any
 * stalled/failed request silently leave keyboard users on /cart with no feedback
 * (WCAG 2.1.1). Both provider branches (discount_code and draft_order) always end
 * in navigation on success, so if we are still on /cart WATCHDOG_MS after an
 * activation, the attempt has failed. This controller only observes activations
 * (capture phase; never preventDefault/stopPropagation) and, on failure, navigates
 * to the provider's own fallback target /checkout. It never fires while a legit
 * flow is in flight: normal provider redirects disarm it via pagehide, and timers
 * that fire late (bfcache restore) are ignored. Inspected 2026-09-28; remove if
 * Orbit ships a native failure-safe fix. */
(function () {
  'use strict';

  var WATCHDOG_ID = 'msgR17CheckoutWatchdog';
  var WATCHDOG_MS = 5000; // provider: ajax (~0.3-2s) + delay_checkout (1s live); guard is 4s
  var LATE_FIRE_MS = 2500; // ignore timers that fire well past their deadline
  var CHECKOUT_SELECTOR = "button[name='checkout'], input[name='checkout']";

  function isCartPage() {
    return /^\/cart(\.html)?([/?#]|$)/.test(window.location.pathname);
  }

  function start() {
    if (!isCartPage()) return;
    if (window[WATCHDOG_ID]) return;
    window[WATCHDOG_ID] = true;

    var timer = null;
    var armedAt = 0;
    var attempts = 0;

    function disarm() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function fire(expectedAttempt) {
      timer = null;
      if (expectedAttempt !== attempts) return; // superseded by a newer activation
      if (Date.now() - armedAt > WATCHDOG_MS + LATE_FIRE_MS) return; // late fire (bfcache)
      if (!isCartPage()) return; // already navigated
      if (document.visibilityState === 'hidden') return; // never navigate a hidden page
      // Provider's own fallback target; Shopify resumes/creates checkout for the cart.
      window.location.assign('/checkout');
    }

    function arm(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest(CHECKOUT_SELECTOR)) return;
      attempts += 1;
      armedAt = Date.now();
      disarm();
      var myAttempt = attempts;
      timer = window.setTimeout(function () {
        fire(myAttempt);
      }, WATCHDOG_MS);
    }

    // Observe pointer and keyboard activation; never intercept either.
    document.addEventListener('click', arm, true);
    document.addEventListener('keydown', function (event) {
      var key = event.key || event.keyCode;
      if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32) {
        arm(event);
      }
    }, true);

    // Any real navigation unloads the page and disarms the watchdog.
    window.addEventListener('pagehide', disarm, true);
    window.addEventListener('beforeunload', disarm, true);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') disarm();
    }, true);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) disarm();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R25 NAV DROPDOWN ARIA SYNC — desktop header dropdown triggers.
 * The theme printed aria-haspopup/aria-expanded on generic wrapper DIVs (invalid;
 * axe aria-allowed-attr) and never updated the state. The attributes now live on
 * the real trigger links; this controller keeps aria-expanded truthful against the
 * three ways a dropdown can open: CSS :hover, JS-added is-opened/show-dropdown
 * classes, and the no-js radio. Zero visual impact; observers are attribute-scoped. */
(function () {
  'use strict';

  var SYNC_ID = 'msgR25NavAriaSync';
  var TRIGGER_SELECTOR = 'a.navbar-link[aria-haspopup="true"]';

  function wrappers() {
    var links = document.querySelectorAll(TRIGGER_SELECTOR);
    var seen = [];
    for (var i = 0; i < links.length; i += 1) {
      var wrap = links[i].closest('.has-dropdown, .has-mega-menu');
      if (wrap && seen.indexOf(wrap) === -1) {
        seen.push(wrap);
      }
    }
    return seen;
  }

  function isOpen(wrap) {
    if (!wrap) return false;
    if (wrap.classList.contains('is-opened') || wrap.classList.contains('show-dropdown')) return true;
    var radio = wrap.querySelector('input.no-js-main-navigation[type="radio"]');
    if (radio && radio.checked) return true;
    return wrap.matches(':hover');
  }

  function sync(wrap) {
    var link = wrap.querySelector(TRIGGER_SELECTOR);
    if (!link) return;
    var wanted = isOpen(wrap) ? 'true' : 'false';
    if (link.getAttribute('aria-expanded') !== wanted) {
      link.setAttribute('aria-expanded', wanted);
    }
  }

  function syncAll() {
    wrappers().forEach(sync);
  }

  function start() {
    if (window[SYNC_ID]) return;
    window[SYNC_ID] = true;

    // Hover opens (delegated; mouseover/out bubble).
    document.addEventListener('mouseover', function (event) {
      var wrap = event.target && event.target.closest ? event.target.closest('.has-dropdown, .has-mega-menu') : null;
      if (wrap) sync(wrap);
    }, true);
    document.addEventListener('mouseout', function (event) {
      var wrap = event.target && event.target.closest ? event.target.closest('.has-dropdown, .has-mega-menu') : null;
      if (wrap) window.setTimeout(function () { sync(wrap); }, 0);
    }, true);

    // JS class-driven opens (click mode is-opened / show-dropdown) and radio state.
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('input.no-js-main-navigation[type="radio"]')) {
        syncAll();
      }
    }, true);

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.target && record.target.classList &&
            (record.target.classList.contains('has-dropdown') || record.target.classList.contains('has-mega-menu'))) {
          sync(record.target);
        }
      });
    });
    wrappers().forEach(function (wrap) {
      observer.observe(wrap, { attributes: true, attributeFilter: ['class'] });
    });

    // Initial truth pass after everything settles.
    window.setTimeout(syncAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R23 SHOGUN IMAGE-LINK NAMER — /pages/kitchen category tiles.
 * Shogun renders image-only collection links with empty alt and no accessible name
 * (WCAG 2.4.4/4.1.2). Content-side fix belongs in Shogun; until then, name each
 * unnamed image-only link from its exact destination pathname using the store's
 * real collection titles. Keyed by pathname: no pattern guessing, no false positives. */
(function () {
  'use strict';

  var NAMER_ID = 'msgR23ShogunLinkNamer';
  var LINK_NAMES = {
    '/collections/online-dips': 'Online Dips',
    '/collections/online-mixes': 'Online Mixes',
    '/collections/kitchen-gadgets': 'Kitchen Gadgets',
    '/collections/online-chocolate-and-candies': 'Online chocolate and Candies',
    '/collections/online-salsa': 'Online Salsa'
  };

  function hasAccessibleName(link) {
    if ((link.getAttribute('aria-label') || '').trim()) return true;
    if ((link.getAttribute('aria-labelledby') || '').trim()) return true;
    if ((link.getAttribute('title') || '').trim()) return true;
    if ((link.textContent || '').trim()) return true;
    var imgs = link.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) {
      if ((imgs[i].getAttribute('alt') || '').trim()) return true;
    }
    return false;
  }

  function nameLinks() {
    var fixed = 0;
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      var pathname;
      try {
        pathname = new URL(link.href, window.location.origin).pathname;
      } catch (_error) {
        continue;
      }
      var name = LINK_NAMES[pathname];
      if (!name || hasAccessibleName(link)) continue;
      if (!link.querySelector('img')) continue; // only image-only links are in scope
      link.setAttribute('aria-label', name);
      fixed += 1;
    }
    return fixed;
  }

  function start() {
    if (window[NAMER_ID]) return;
    window[NAMER_ID] = true;
    nameLinks();
    // One bounded retry for any late-appended Shogun nodes.
    var retries = 0;
    var timer = window.setInterval(function () {
      retries += 1;
      nameLinks();
      if (retries >= 6) window.clearInterval(timer);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
